<template>
  <div class="register-page">
    <div class="bg-mask"></div>
    <div class="register-wrapper">
      <div class="register-inner">
        <img class="logo" src="@/assets/images/logo.png" />
        <div class="register-box" :class="focus ? 'focus' : ''">
          <i class="icon-email"></i>
          <el-input
            v-model="loginForm.email"
            @focus="handleFocus"
            @blur="handleBlur"
            placeholder="Email Address" />
          <el-button @click="handleRegister"
            >Kraze Me <i class="icon-right"></i
          ></el-button>
        </div>
        <div class="dess">Enter Email Address to Unlock Kraze Benefits.</div>
      </div>
    </div>

    <mt-popup
      v-model="popupVisible"
      :position="this.mobile ? 'bottom' : 'center'"
      :modal="false"
      :closeOnClickModal="false">
      <div class="pop-box buy" v-if="popType === 'success'">
        <div class="result-box" style="margin-top: 0.22rem">
          <div class="h icons success2">Thank you for your participation!</div>
          <div class="des">
            We will notify you via email for upcoming activities!
          </div>
        </div>
        <el-button
          class="el-button--white block"
          style="margin-top: 0.55rem"
          @click="handleSuccess"
          >OK</el-button
        >
      </div>
    </mt-popup>
  </div>
</template>
<script>
import { postSubscribeSubmit } from '@/api/user'
import { Toast } from 'mint-ui'

export default {
  name: 'RegisterPage',
  components: {},
  data() {
    return {
      loginForm: {
        email: ''
      },
      focus: false,
      popupVisible: false,
      popType: null,
      mobile: false
    }
  },
  mounted() {
    let width = document.body.clientWidth
    if (width > 750) {
      this.mobile = false
    } else {
      this.mobile = true
    }
  },
  methods: {
    handleFocus() {
      this.focus = true
    },
    handleBlur() {
      this.focus = false
    },
    // 检查email邮箱
    isEmail(str) {
      var reg =
        /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/
      return reg.test(str)
    },
    handleSuccess() {
      this.popupVisible = false
      this.popType = null
      this.loginForm.email = ''
    },
    handleRegister() {
      if (this.loginForm.email === '') {
        Toast({
          message: 'Please Enter The Email',
          iconClass: 'icon icon-warning',
          duration: 2000
        })
        return
      }

      if (!this.isEmail(this.loginForm.email)) {
        Toast({
          message: 'Please Enter The Correct Email',
          iconClass: 'icon icon-warning',
          duration: 2000
        })
        return
      }
      postSubscribeSubmit(this.loginForm)
        .then((res) => {
          if (res) {
            this.popType = 'success'
            this.popupVisible = true
          }
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/index.vue